export default class Home {
  constructor(container) {
    this.container = container;

    this.init();
  }

  init() {
  }

  destroy(){}
}
